// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const { getContentFormContainer } =
  require("../../manage/methods/ContentFormUtils").default
const { EMBED, LISTED } = require("./ManageAssessmentConfig").default

const ManageAssessmentEditor = require("./ManageAssessmentEditor").default

export const assessment_editor = {
  icon: "list-two-column",
  title: "Build a quiz or test",
  prompt: "To take here on any device",
  form: ManageAssessmentEditor
}
export const assessment_listing = {
  icon: "file-code",
  title: "Reference an external assessment",
  prompt: "Taken in class, as a download,...",
  form: getContentFormContainer(LISTED)
}
export const embed = {
  icon: "share",
  title: "Embed a survey or quiz",
  prompt: "Embed a Typeform, Google form, Qzzr.com, etc.",
  form: getContentFormContainer(EMBED)
}
